// Copyright (c) 2023 Jürgen Gebath
//
// This software is released under the MIT License.
// https://opensource.org/licenses/MIT
import * as React from "react";
import { Grid, Typography } from "@mui/material";
import Contact from "./Contact";
import { Link } from "react-router-dom";
import { styled } from "@mui/material/styles";
import { useTheme } from "@mui/material/styles";

const StyledLink = styled((props) => <Link {...props} />)(({ theme }) => ({
  color: theme.palette.text.brand,
}));

function Copyright() {
  return (
    <Typography variant="body2">
      {"Copyright © "}
      Feuerwehr Großrust-Merking {new Date().getFullYear()}
      <br />
      <StyledLink to="/Rechtliches">Impressum</StyledLink>
    </Typography>
  );
}

export default function Footer() {
  const theme = useTheme();
  return (
    <Grid
      container
      sx={(theme) => ({
        width: "100%",
        backgroundColor: theme.palette.brand.main,
        justifyContent: "center",
        marginTop: 7,
      })}>
      <Grid
        container
        item
        direction="row"
        alignItems="center"
        justifyContent="space-between"
        sx={(theme) => ({
          backgroundColor: theme.palette.brand.main,
          color: theme.palette.text.brand,
          paddingX: "24px",
          maxWidth: "1200px",
        })}>
        <Contact firstCellColor={theme.palette.text.brand}></Contact>

        <Grid
          item
          textAlign="right">
          <Copyright />
        </Grid>
      </Grid>
    </Grid>
  );
}
